import React, { Component } from 'react';
import { AuthContext } from "./../../context/auth";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";

class TopCartComponent extends Component{
    static contextType = AuthContext;
    state = {
        loginmodal:false
    }

    handleLoginModalClose = () => {
        this.setState({
            loginmodal : false
        })
    }

    handleLoginModalConfirm = () => {
        this.handleLoginModalClose();
    }

    handleLoginModalClick = (event) => {
        if(!this.context.authenticated) {
            event.preventDefault()
            this.setState({
                loginmodal: true
            })
            return false;
        }
    }

    render(){
        return (
            <React.Fragment>
                <Modal id="unfollow-pop" show={this.state.loginmodal} aria-labelledby="unfollow-pop" animation="fade">
                    <Modal.Header className="modal-header">
                        <p className="big-alert-text"><i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
                            Alert
                        </p>
                        <button type="button" className="close" onClick={this.handleLoginModalClose}  aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </Modal.Header>
                    <Modal.Body className="modal-body">
                        <p className="unfollow-para">You have to login/register to proceed further.</p>
                    </Modal.Body>
                    <Modal.Footer className="modal-footer">
                        <Link to={`${process.env.PUBLIC_URL}/cart`} className="w-50"><button className="w-100 btn btn-primary" type="button" data-dismiss="modal">Ok</button></Link>
                        <button type="button" onClick={this.handleLoginModalClose} className="btn btn-primary" data-dismiss="modal">Cancel</button>
                    </Modal.Footer>
                </Modal>
                <ul className="list-unstyled d-inline-block mb-0">
                    <li>
                        {!this.context.authenticated ?
                            <Link onClick={this.handleLoginModalClick.bind(this)} to={`${process.env.PUBLIC_URL}/cart`} className="cart-icon">
                                {this.context.cartCount > 0 && <span className="cart-badge">{this.context.cartCount}</span>}
                            </Link>
                            :
                            <Link to={`${process.env.PUBLIC_URL}/cart`} className="cart-icon">
                                {this.context.cartCount > 0 && <span className="cart-badge">{this.context.cartCount}</span>}
                            </Link>
                        }
                    </li>
                </ul>
            </React.Fragment>
        );
    }
}

export default TopCartComponent;